module.exports = "<app-qavisit [title]=\"title\" [status] = \"status\" [isReviewed] = \"isReviewed\" [hideActionsColumn]=\"hideActions\"></app-qavisit>"